import { all } from 'redux-saga/effects';
import { Saga } from 'redux-saga';
import { ActionFunctionAny, Action } from 'redux-actions';
import { emailExample } from './emailExample';
import { pastOrders } from './PastOrders';
import { app } from './App';
import { analytics } from './analytics';

export const matchesType = (actionCreator: ActionFunctionAny<any>) =>
    (action: Action<any>) =>
        actionCreator().type === action.type;

const sagas: Saga[] = [
    emailExample,
    pastOrders,
    app,
    analytics,
];

export default function*() {
    yield all([...sagas].map((saga) => saga()));
}
